export interface ScheduleSearch {
  week?: string;
  days?: 1 | 3 | 7;
}

export const validateScheduleSearch = (
  search: Record<string, unknown>,
): ScheduleSearch => ({
  week: typeof search.week === "string" ? search.week : undefined,
  days:
    search.days === 1 || search.days === 3 || search.days === 7
      ? search.days
      : undefined,
});
